import { PATHS } from '@api/paths';
import { generateHttpClient } from '@api/httpClient';

import order from '@api/endpoints/order';
import fingerprint from '@api/endpoints/fingerprint';
import ip from '@api/endpoints/ip';

export const generateApi = (baseURL: string, requestId?: string) => ({
  order: order(generateHttpClient(baseURL, requestId), PATHS.BASE_URL),
  fingerprint: fingerprint(
    generateHttpClient(baseURL, requestId),
    PATHS.BASE_URL
  ),
  ip: ip(generateHttpClient(baseURL, requestId), PATHS.BASE_URL),
});
